module.exports = __webpack_public_path__ + "img/kommune-1834.16db6f46.svg";